// extracted by mini-css-extract-plugin
export default {"button":"AddButton_button__8hM+N","text":"AddButton_text__lHMyI"};